module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "business-page"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('content'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('developCooperation')) + "：business@mngo.com")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('issueCooperation')) + "：business@enjoygame.com")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('hr')) + "：zhaopin@mngo.com")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56d98325!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Business.vue
// module id = 377
// module chunks = 8